import { render, staticRenderFns } from "./StepNumber.vue?vue&type=template&id=6539438c"
import script from "./StepNumber.vue?vue&type=script&lang=js"
export * from "./StepNumber.vue?vue&type=script&lang=js"
import style0 from "./StepNumber.vue?vue&type=style&index=0&id=6539438c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports